<template>
  <div class="text-center">
    <div class="text-danger" v-if="game">
      <img :src="game.thumbnail"/> <br/>
      {{ game.name }} by {{ game.vendor }}
    </div>
  </div>
</template>

<script>
    export default {
        name: 'gameCard',
        data () {
            return {
                game: null
            }
        },
        props: ['gameId', 'vendor'],
        mounted () {
            this.fetchGame();
        },
        methods: {
            fetchGame () {
                this.$http.get(bsapi+'api/v1/casino/game/'+this.vendor+'/'+this.gameId).then(response => {
                    // get body data
                    this.game = response.body.result;
                    this.status = response.status;
                }, response => {
                    this.status = response.status;
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/casino/gameCard.vue